var loginDetails = [
{ "username": "fmoh_director_dprs", "password": "dprsdir#19", "location": "FMOH Director DPRS", "body": "FMOH"},
{ "username": "fmoh_perm_sec", "password": "123456", "location": "PERM. Sec. FMOH", "body": "FMOH"},
{ "username": "hmh_fmoh", "password": "123456", "location": "HMH FMOH", "body": "FMOH"},
{ "username": "fmoh_public_health", "password": "123456", "location": "FMOH Public Health", "body": "FMOH"},
{ "username": "fmoh_ict", "password": "123456", "location": "FMOH ICT", "body": "FMOH"},
{ "username": "fmoh_dprs_mne", "password": "dirmne#19", "location": "FMOH DPRS MnE", "body": "FMOH"},
{ "username": "nphcda_ed", "password": "ednphcda$19", "location": "NPHCDA ED", "body": "NPHCDA"},
{ "username": "nphcda_dprs", "password": "nphcdadprs$19", "location": "NPHCDA DPRS", "body": "NPHCDA"},
{ "username": "nericc", "password": "nericc$#19", "location": "NERICC", "body": "NPHCDA"},
{ "username": "admin", "password": "dashboard", "location": "Admin", "body": "e4e"},
{ "username": "bmgf", "password": "dashboard", "location": "Admin", "body": "bmgf"},
{ "username": "superadmin", "password": "Chukwuma123", "location": "Admin", "body": "bmgf"},
];

module.exports = loginDetails;



// WEBPACK FOOTER //
// ./src/components/Auth/logindetails.js